import React from 'react';
import { useCurrency } from '../../hooks/useCurrency';

// This acts as a global wrapper. Any page using <Price amount={100} /> 
// will automatically get the correct math and symbol based on the active currency!
const Price = ({ amount, className = "" }) => {
    const { formatMoney } = useCurrency();

    return (
        <span className={className}>
            {formatMoney(amount)}
        </span>
    );
};

export default Price;